<template>
	<div class="import" id="import">
		<ImportCard></ImportCard>
	</div>
</template>

<script>
import ImportCard from './import/ImportCard'

export default {
	name: 'import-patient',

	components: {
		ImportCard
	}
}
</script>